import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { signUpWithEmail } from '@/lib/platform/auth';
import { enterAfterAuth } from '@/lib/platform/routing';
import { entry } from '@/routes';

export function SignUpPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string>();
  const [busy, setBusy] = useState(false);
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
      <div className="w-full max-w-md border border-border bg-card p-8">
        <p className="text-sm font-semibold tracking-[0.18em]">FIDUCIARYFILE</p>
        <h1 className="mt-10 text-3xl font-semibold tracking-tight">Create your account</h1>
        <p className="mt-2 text-sm text-muted-foreground">Set up a confidential workspace for your filing team.</p>
        <div className="mt-8 grid gap-5">
          <div className="grid gap-2">
            <Label htmlFor="name">Name</Label>
            <Input id="name" value={name} onChange={(event) => setName(event.target.value)} />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          {message && <p className="text-sm text-destructive">{message}</p>}
          <Button
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              setMessage(undefined);
              const result = await signUpWithEmail(name, email, password);
              if (result.ok) await enterAfterAuth(entry);
              else setMessage(result.message);
              setBusy(false);
            }}
          >
            {busy ? 'Creating account…' : 'Create account'}
          </Button>
        </div>
        <p className="mt-6 text-sm text-muted-foreground">
          Already have an account?{' '}
          <Link className="text-primary underline" to="/sign-in">
            Sign in
          </Link>
        </p>
      </div>
    </main>
  );
}
